export const truncate = (text: string, stop: number) => {
  if (!text) return '';
  return text.slice(0, stop) + (stop < text.length ? '...' : '');
};

// oxlint-disable-next-line no-control-regex
export const sanitiseUTF8 = (text: string) => text.replace(/\x00/g, '');

// en-US list formatting adds the Oxford comma the copy guide asks for, which en-GB
// leaves out.
const conjunctionList = new Intl.ListFormat('en-US', { type: 'conjunction' });

export const formatList = (items: string[]) => conjunctionList.format(items);
